import React, { RefObject, useCallback, useEffect } from 'react';
import { useState } from 'react';
import { AppSelectOption } from "src/commun/composants/formulaire/AppSelect/AppSelect";
import AppIcon from "src/commun/composants/AppIcon";
import styles from "./AppDropdownCheckbox.scss";


export type AppDropdownCheckboxProps = {
  label: string;
  name: string;
  options: AppSelectOption[];
  checked: AppSelectOption[];
  onChange: (param: any) => void;
  fieldRef?: RefObject<HTMLInputElement>;
} & React.ComponentProps<"input">;


const AppDropdownCheckbox = ({ label, options, checked, onChange, fieldRef }: AppDropdownCheckboxProps) => {
  const [isOpen, setIsOpen] = useState(false);


  // Fermer le select lorsqu'on clique ailleurs
  const hideDropdown = useCallback(
    (event: MouseEvent) => {
      if (fieldRef?.current && !fieldRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    },
    [fieldRef],
  );

  useEffect(() => {
    document.addEventListener("mousedown", hideDropdown);

    return () => {
      document.removeEventListener("mousedown", hideDropdown);
    };
  }, [hideDropdown]);

  return (
    <div className="dropdown-checkbox">
      <span onClick={() => setIsOpen(!isOpen)}>
        <label>{label}
          <AppIcon
          name="bas"
          className="select-icon"
          style={{
            position: "relative",
            top: "10px",
            fontSize: "32px",
          }}
          />
        </label>
      </span>
        {isOpen && (
          <div className={styles.dropdownContent} ref={fieldRef}>
            {options.map((option) => (
              <p key={option.value}>
                <label>
                  <input
                    type="checkbox"
                    className={styles.checkbox}
                    checked={checked.map(item => item.value).includes(option.value)}
                    onChange={() => onChange(option)}
                  />
                  {option.label}
                </label>
              </p>
            ))}
          </div>
        )}
    </div>
  );
};

export default AppDropdownCheckbox;